module.exports = __webpack_public_path__ + "img/17_78.4f40be1e.png";